import { api_GET, api_POST, api_PUT, api_DELETE, api_POST_File } from "./api_service.js";

// Gestor
export const ListarCorreioInterno = (filtro) => {
  const query = new URLSearchParams();

  if (filtro) {
    if (filtro.titulo) query.append("Titulo", filtro.titulo);
    if (filtro.tipoEnvio) query.append("TipoEnvio", filtro.tipoEnvio);
    if (filtro.status) query.append("Status", filtro.status);
    if (filtro.dataCadastroInicio) query.append("DataCadastroInicio", filtro.dataCadastroInicio);
    if (filtro.dataCadastroFim) query.append("DataCadastroFim", filtro.dataCadastroFim);
    if (filtro.pagina) query.append("Pagina", filtro.pagina);
    if (filtro.registrosPorPagina) query.append("RegistrosPorPagina", filtro.registrosPorPagina);
  }

  const parametros = query.toString();

  return api_GET(`CorreioInterno${parametros ? `?${parametros}` : ""}`);
};

export const ObterCorreioInterno = (correioInterno_Id) =>
  api_GET(`CorreioInterno/${correioInterno_Id}`);

export const ListarCategoriasCorreioInterno = () =>
  api_GET("CorreioInterno/Categorias");

export const ListarDestinatariosCorreioInterno = (correioInterno_Id) =>
  api_GET(`CorreioInterno/${correioInterno_Id}/Destinatarios`);

// Simula o envio sem gravar: totais de destinatarios que o rascunho alcancaria agora.
export const PreviaDestinatariosCorreioInterno = (correioInterno_Id) =>
  api_GET(`CorreioInterno/${correioInterno_Id}/PreviaDestinatarios`);

export const IncluirCorreioInterno = (dados) =>
  api_POST("CorreioInterno", dados);

export const AlterarCorreioInterno = (correioInterno_Id, dados) =>
  api_PUT(`CorreioInterno/${correioInterno_Id}`, dados);

export const ExcluirCorreioInterno = (correioInterno_Id) =>
  api_DELETE(`CorreioInterno/${correioInterno_Id}`);

export const EnviarCorreioInterno = (correioInterno_Id) =>
  api_POST(`CorreioInterno/${correioInterno_Id}/Enviar`, {});

export const ObterStatusEnvioCorreioInterno = (correioInterno_Id) =>
  api_GET(`CorreioInterno/${correioInterno_Id}/StatusEnvio`);

export const ReenviarFalhasCorreioInterno = (correioInterno_Id) =>
  api_POST(`CorreioInterno/${correioInterno_Id}/ReenviarFalhas`, {});

// Sobe imagem ou PDF usado na descrição do aviso e devolve a URL pública do arquivo.
export const EnviarArquivoCorreioInterno = (formData) =>
  api_POST_File("CorreioInterno/Arquivo", formData);

// Portal (acesso do protocolo)
export const ListarAvisosNaoLidos = (protocolo_Id) =>
  api_GET(`CorreioInterno/Portal/${protocolo_Id}`);

export const ListarAvisosLidos = (protocolo_Id) =>
  api_GET(`CorreioInterno/Portal/${protocolo_Id}/Lidos`);

export const MarcarAvisoComoLido = (protocolo_Id, correioInterno_Id) =>
  api_POST(`CorreioInterno/Portal/${protocolo_Id}/Lido/${correioInterno_Id}`, {});
